export default __webpack_public_path__ + "static/media/4089a3ad879891fd4cf34c7947bc080a.370127c7.svg";